import React, { useState } from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

/**
 * Componente para filtros y controles de la lista de usuarios
 */
const UserFilters = ({ 
  searchTerm, 
  onSearchChange, 
  statusFilter, 
  onStatusFilterChange,
  moduleFilter,
  onModuleFilterChange,
  modulos,
  totalUsers,
  filteredUsers 
}) => {

  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '20px',
      border: '1px solid #dee2e6'
    }}>
      <Row className="align-items-center">
        {/* Búsqueda */}
        <Col md={4}>
          <Form.Group>
            <Form.Label style={{ fontSize: '12px', fontWeight: '600', marginBottom: '4px' }}>
              Buscar usuarios
            </Form.Label>
            <InputGroup>
              <InputGroup.Text style={{ backgroundColor: 'white', border: '1px solid #ced4da' }}>
                <FaIcons.FaSearch style={{ fontSize: '12px', color: '#6c757d' }} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Nombre, email..."
                value={searchTerm}
                onChange={onSearchChange}
                style={{ fontSize: '14px' }}
              />
            </InputGroup>
          </Form.Group>
        </Col>

        {/* Filtro por Estado */}
        <Col md={2}>
          <Form.Group>
            <Form.Label style={{ fontSize: '12px', fontWeight: '600', marginBottom: '4px' }}>
              Estado
            </Form.Label>
            <Form.Select
              value={statusFilter}
              onChange={onStatusFilterChange}
              style={{ fontSize: '14px' }}
            >
              <option value="all">Todos</option>
              <option value="active">Activos</option>
              <option value="inactive">Inactivos</option>
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Filtro por Módulo */}
        <Col md={3}>
          <Form.Group>
            <Form.Label style={{ fontSize: '12px', fontWeight: '600', marginBottom: '4px' }}>
              Filtrar por módulo
            </Form.Label>
            <Form.Select
              value={moduleFilter}
              onChange={onModuleFilterChange}
              style={{ fontSize: '14px' }}
            >
              <option value="all">Todos los módulos</option>
              {modulos?.map(modulo => (
                <option key={modulo.id} value={modulo.modulo}>
                  {modulo.descripcion}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Estadísticas */}
        <Col md={3}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#007bff' }}>
              {filteredUsers}/{totalUsers}
            </div>
            <div style={{ fontSize: '12px', color: '#6c757d' }}>
              usuarios mostrados
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UserFilters;
